import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import OrderHistory from '@/components/common/icons/order-history.svg';
import renderSvg from '@/utils/renderSvg';
import Icon from './Icon';

const ActivityLogComponent = ({ intl, historic }) => {
  return (
    <div className="w-full bg-white">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        {renderSvg(OrderHistory, {
          alt: '',
          className: 'text-[calc(14px+0.6vw)] mr-[1vw] w-[calc(14px+0.6vw)] h-[calc(14px+0.6vw)] align-middle',
        })}
        <FormattedMessage id="ORDER_HISTORY" />
      </div>

      <div className="flex flex-col mt-[1.2vw] mb-[0.5vw] text-[#858585]">
        {/* Timeline Header */}
        <div className="flex justify-between w-full mb-[1vw] text-[calc(7px+0.4vw)] font-bold leading-relaxed">
          <div className="grow pl-[0.5vw]">{intl.formatMessage({ id: 'ACTION' })}</div>
          <div className="grow">{intl.formatMessage({ id: 'username' })}</div>
          <div className="w-[8vw] min-w-[100px]">{intl.formatMessage({ id: 'DATE_AND_TIME' })}</div>
        </div>

        <div>
          {historic &&
            historic.map((record, index) => (
              <Fragment key={record.id}>
                <div
                  className="relative flex justify-between w-full text-[calc(5px+0.4vw)]"
                  style={{ paddingBottom: !record.notes ? '4em' : '0.5em' }}
                >
                  {/* Vertical dotted line */}
                  {historic.length > index + 1 && (
                    <div className="absolute left-[10px] top-[1px] h-full border-l border-dotted border-[#858585] z-[1]"></div>
                  )}

                  <div className="w-[40%] flex items-center grow">
                    <div className="relative flex justify-center items-center w-[21px] h-[21px] min-w-[21px] min-h-[21px] border-2 border-white rounded-full bg-white z-[2] shadow-sm">
                      <Icon action={record.type} className="w-full h-full rounded-full z-[2]" />
                    </div>
                    <div className="ml-[0.5vw] truncate pr-[0.5vw]">{intl.formatMessage({ id: record.type })}</div>
                  </div>

                  <div className="w-[40%] flex items-center grow truncate pr-[0.5vw]">{record.user_identification}</div>

                  <div className="w-[20%] flex items-center shrink-0 min-w-[100px]" title={record.humanDate}>
                    {record.date}
                  </div>
                </div>

                {record.notes && (
                  <div className="relative flex justify-between w-full pb-[4em] text-[calc(5px+0.4vw)]">
                    {/* Vertical dotted line continuation */}
                    <div
                      className="absolute left-[10px] top-[0px] h-full border-l border-dotted border-[#858585] z-[1]"
                      style={{ display: index === historic.length - 1 ? 'none' : 'block' }}
                    ></div>

                    <div className="flex items-center">
                      {/* Observation "hook" logic */}
                      <div className="mt-[-10px] ml-[10px] mr-[12px] bg-[#858585] h-[12px] w-[1px] relative">
                        <div className="absolute top-[12px] left-0 w-[15px] h-[1px] bg-[#858585]"></div>
                      </div>
                      <div className="ml-[0.5vw] italic opacity-80">{record.notes}</div>
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
        </div>
      </div>
    </div>
  );
};

ActivityLogComponent.propTypes = {
  intl: PropTypes.object.isRequired,
  historic: PropTypes.array.isRequired,
};

export default ActivityLogComponent;
